export const ModalKeys = {
  ABOUT: 'about',
  PREFERENCES: 'preferences',
  CHANGE_PASSWORD: 'change-password'
} as const;

export type ModalKey = (typeof ModalKeys)[keyof typeof ModalKeys];

export const MODAL_QUERY_PARAM = 'modal';
